module.exports = __webpack_public_path__ + "static/media/GitHubIcon.1108618d.png";